// extracted by mini-css-extract-plugin
export default {"rating":"nM-z","numberOfStars":"oM-z","count":"pM-z","barGraphSpacing":"qM-z","barGraph":"rM-z"};